export default "__VITE_ASSET__DyhEbnvR__"